// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tpVP","index":"styles_index__1mxc3"};